import React from 'react'
import { useWindowDimensions, ScrollView, View } from 'react-native'
import { Text } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'

import { SafeAreaView } from 'react-native-safe-area-context'
import RenderHtml from 'react-native-render-html'
import { useMediaQuery } from 'react-responsive'


const source1 = {
  html: `
<p style='text-align:left; font-size: smaller; line-height: 18px;'>SENAC BAHIA - TERÇA-FEIRA - 20 DE AGOSTO DE 2021</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>O SENAC BAHIA tem o compromisso com a privacidade e a segurança de seus clientes durante todo o processo de coleta de dados. Os dados cadastrais dos clientes e prospectos não são vendidos, trocados ou divulgados para terceiros.</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>O SENAC BAHIA utiliza cookies e informações de sua navegação (sessão do browser) no site http://solucoesempreendedoras.ba.senac.br/ com o objetivo de traçar um perfil do público que visita o site e aperfeiçoar sempre nossos serviços e conteúdos. Durante todo este processo mantemos suas informações em sigilo absoluto. Vale lembrar que seus dados são registrados pelo SENAC BAHIA de forma automatizada, dispensando manipulação humana.</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>O SENAC BAHIA, quando aplicável, realizará o tratamento dos DADOS fundada em seu legítimo interesse, nos termos da Lei 13.709/2018, desde que se mantenham respeitados os direitos e liberdades fundamentais dos clientes.</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Utilizamos “retargeting” do Facebook visando te mostrar conteúdos relevantes.</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>As alterações sobre nossa política de privacidade serão devidamente informadas neste espaço.</p>
`
};

export default function Privacidade() {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height

      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="POlÍTICA DE PRIVACIDADE" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-5 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
            <View style={[tailwind('mb-10'), {marginTop: isLargeScreen ? 110 : 150}]}>
                <Text style={[tailwind('my-3 font-bold p-5'), { backgroundColor: Colors.roxo, color: 'white' }]}>Campanha de Geração de Cadastros</Text>
                <View style={tailwind('mx-5 mb-10')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source1}
                  />
                </View>  
              </View>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
